import React, { useState } from "react";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";

const PeopleStep = ({
    handleStep,
    soundClick,
    error,
    loadingSteps,
    selectedTeam,
    setSelectedTeam
}) => {
    const { t } = useLanguage()
    const clickAction = (item) => {
        soundClick()
        setSelectedTeam(item)
    }

    return (
        <div className="steps_main_container">
            <div className="welcome_step_cont">
                <div className="welcome_step_cont_inner">
                    <p className="step_title fade-in">{t.onboarding.team.title}</p>
                    <p className="step_description fade-in">{t.onboarding.team.subtitle}</p>
                    <div className="people_choise_cont_steps">
                        {t.onboarding.team.about_you_options.map((item) => (
                            <div key={item.value} className={`people_choise_steps fade-in ${selectedTeam == item.value && "people_choise_steps_selected"}`} onClick={() => clickAction(item.value)}>{item.label}</div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="steps_btn_cont">
                <button
                    className="steps_btn"
                    onClick={() => handleStep("back", "about-you")}
                >
                    <i className="fa-solid fa-chevron-left"></i> {t.onboarding.back}
                </button>
                <div>
                    <ErrorMessage err={error} />
                </div>
                <button className="steps_btn fade-in" onClick={() => handleStep("continue", "subscription")}>
                    {loadingSteps ? (
                        <Spinner loading={true} />
                    ) : (
                        <>{t.onboarding.continue} <i className="fa-solid fa-chevron-right"></i></>
                    )}
                </button>
            </div>
        </div>
    );
};

export default PeopleStep;